import React, { useState } from "react";
import Icon from "../../../components/AppIcon";

const ORANGE = "#F27E33";
const NAVY   = "#1D2946";
const CYAN   = "#00D4FF";

// util simple
const cn = (...c) => c.filter(Boolean).join(" ");

export default function ContactForm() {
  const [loading, setLoading] = useState(false);
  const [ok, setOk] = useState(false);
  const [form, setForm] = useState({
    nombre: "",
    email: "",
    telefono: "",
    empresa: "",
    servicio: "",
    mensaje: "",
  });

  const onChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

    const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setOk(false);

    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form), // { nombre, email, telefono, empresa, servicio, mensaje }
      });

      const data = await res.json();
      if (res.ok && data?.ok) {
        setOk(true);
        setForm({
          nombre: "",
          email: "",
          telefono: "",
          empresa: "",
          servicio: "",
          mensaje: "",
        });
      } else {
        throw new Error(data?.message || "No se pudo enviar tu solicitud.");
      }
    } catch (err) {
      console.error("CONTACT_FORM_ERROR", err);
      alert("Ocurrió un error enviando tu solicitud. Intenta nuevamente.");
    } finally {
      setLoading(false);
      setTimeout(() => setOk(false), 4000);
    }
  };

  return (
    <div
      className="rounded-2xl p-6 relative"
      style={{
        background: "rgba(255,255,255,.08)",
        border: "1px solid rgba(255,255,255,.15)",
        backdropFilter: "blur(6px)",
        boxShadow: `inset 0 0 60px ${ORANGE}22`,
      }}
    >
      {/* tira decorativa */}
      <div
        className="absolute -top-[1px] left-0 h-1 w-36 rounded-tr"
        style={{
          background: `linear-gradient(90deg, ${ORANGE}, ${NAVY})`,
        }}
      />

      <h3 className="font-orbitron text-white text-xl mb-2">
        Cuéntanos de tu proyecto
      </h3>
      <p className="font-body text-white/80 text-sm mb-6">
        Responde estos campos y te contactaremos en menos de 24 horas hábiles.
      </p>

      <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="font-body text-white/70 text-xs">Nombre</label>
          <input
            className="w-full mt-1 rounded-lg bg-white/90 text-[#0A1420] px-3 py-2 outline-none focus:ring-2"
            style={{ boxShadow: "inset 0 0 0 1px rgba(0,0,0,.05)" }}
            name="nombre"
            value={form.nombre}
            onChange={onChange}
            required
          />
        </div>

        <div>
          <label className="font-body text-white/70 text-xs">Correo</label>
          <input
            type="email"
            className="w-full mt-1 rounded-lg bg-white/90 text-[#0A1420] px-3 py-2 outline-none focus:ring-2"
            style={{ boxShadow: "inset 0 0 0 1px rgba(0,0,0,.05)" }}
            name="email"
            value={form.email}
            onChange={onChange}
            required
          />
        </div>

        <div>
          <label className="font-body text-white/70 text-xs">Teléfono</label>
          <input
            className="w-full mt-1 rounded-lg bg-white/90 text-[#0A1420] px-3 py-2 outline-none focus:ring-2"
            style={{ boxShadow: "inset 0 0 0 1px rgba(0,0,0,.05)" }}
            name="telefono"
            value={form.telefono}
            onChange={onChange}
          />
        </div>

        <div>
          <label className="font-body text-white/70 text-xs">Empresa (opcional)</label>
          <input
            className="w-full mt-1 rounded-lg bg-white/90 text-[#0A1420] px-3 py-2 outline-none focus:ring-2"
            style={{ boxShadow: "inset 0 0 0 1px rgba(0,0,0,.05)" }}
            name="empresa"
            value={form.empresa}
            onChange={onChange}
          />
        </div>

        <div className="md:col-span-2">
          <label className="font-body text-white/70 text-xs">Servicio de interés</label>
          <select
            className="w-full mt-1 rounded-lg bg-white/90 text-[#0A1420] px-3 py-2 outline-none focus:ring-2"
            style={{ boxShadow: "inset 0 0 0 1px rgba(0,0,0,.05)" }}
            name="servicio"
            value={form.servicio}
            onChange={onChange}
          >
            <option value="">Selecciona...</option>
            <option>Obra Civil</option>
            <option>Acabados</option>
            <option>Mantenimiento Locativo</option>
            <option>Comunicaciones</option>
            <option>Hidrosanitarios</option>
            <option>Mobiliario</option>
            <option>Sistemas Eléctricos</option>
            <option>Espacios Públicos</option>
            <option>Gas Natural</option>
            <option>Vidrio Aluminio</option>
          </select>
        </div>

        <div className="md:col-span-2">
          <label className="font-body text-white/70 text-xs">Descripción del proyecto</label>
          <textarea
            rows={5}
            className="w-full mt-1 rounded-lg bg-white/90 text-[#0A1420] px-3 py-2 outline-none focus:ring-2"
            style={{ boxShadow: "inset 0 0 0 1px rgba(0,0,0,.05)" }}
            name="mensaje"
            value={form.mensaje}
            onChange={onChange}
            placeholder="Área/metros, ciudad, alcance, tiempos, restricciones, etc."
          />
        </div>

        <div className="md:col-span-2 flex items-center justify-between gap-3">
          <label className="flex items-center gap-2 text-white/70 text-xs">
            <input type="checkbox" required /> Acepto el tratamiento de datos.
          </label>

          <button
            type="submit"
            disabled={loading}
            className={cn(
              "font-orbitron inline-flex items-center gap-2 rounded-xl px-5 py-2.5 transition border",
              "bg-white text-[#0B1620]"
            )}
            style={{
              borderColor: "rgba(0,0,0,.06)",
              boxShadow: loading ? `0 0 0 3px ${ORANGE}30, 0 0 0 6px ${ORANGE}10` : "none",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.boxShadow = `0 0 0 3px ${ORANGE}44`)}
            onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
          >
            {loading ? "Enviando..." : "Enviar solicitud"}
            <span style={{ color: ORANGE }}>↗</span>
          </button>
        </div>
      </form>

      {/* Toast simple */}
      {ok && (
        <div
          className="mt-4 rounded-lg px-4 py-3 font-body text-sm"
          style={{
            background: "rgba(60,203,127,.15)",
            border: "1px solid rgba(60,203,127,.35)",
            color: "#CFF3E2",
          }}
        >
          ¡Gracias! Tu solicitud fue enviada. Te contactaremos pronto.
        </div>
      )}
    </div>
  );
}
